import { Modal, ModalHeader, ModalBody, Col, Row, Button, Input } from 'reactstrap';
import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { FaInfoCircle } from 'react-icons/fa';

export const hasPrivilege = (privileges, required, superAdmin) => {
    return superAdmin ? superAdmin : privileges && privileges.some(value => required.indexOf(value) >= 0);
}

export const getPoolRole = (pool, roles) => {
    return  roles && roles.filter(value => value.startsWith(pool));   
}

export const generatePoolObject = (formData) => {
	const {
		address,
		given_name,
		family_name,
		custom_telephone,
		custom_displayname,
		custom_company,
		custom_Groups,
		custom_sonyrelationship,
		custom_status,
		custom_city,
		custom_state,
		custom_zip,
		custom_country,
		distributorAccount,
		phone_number,
		custom_sapcontactid,
	    custom_sapAccountid,
		custom_resourceid,
		custom_contracttype,
		custom_salesOrg,
		email
	} = { ...formData };
	return {
		'email': email,
		'given_name': given_name,
		'name': custom_company,
		'family_name': family_name,
		'address': address,
		'phone_number': phone_number,
		'custom:displayname': custom_displayname,
		'custom:company': custom_company,
		'custom:phoneNumber': custom_telephone,
		'custom:mobileNumber': phone_number,
		'custom:Groups': custom_Groups,
		'custom:sonyrelationship': custom_sonyrelationship,
		'custom:status': custom_status,
		'custom:Address': address,
		'custom:City': custom_city,
		'custom:State': custom_state,
		'custom:Zip': custom_zip,
		'custom:Country': custom_country,
		'custom:sapcontactid':custom_sapcontactid,
		'custom:sapAccountid':custom_sapAccountid,
		'custom:resourceid':custom_resourceid,
		'custom:contracttype':custom_contracttype,
		'custom:salesOrg':custom_salesOrg,
		'custom:distributorAccount': distributorAccount
		// custom_distributoraccount
	};
};

export const CustomDialog = props => (
	<div>
	  <Modal isOpen={props.modal} toggle={props.toggle} centered>
		<ModalHeader toggle={props.toggle}>{props.header}</ModalHeader>
		<ModalBody>
		  <h5 style={{ textAlign: 'center' }}>
			{props.message}
			{!props.showTextArea && <br />}
			{props.showTextArea && props.textarealabel}
		  </h5>
		  {props.commentRequired && <div style={{ color: '#ff0000', paddingLeft:'13%', fontSize:'13px' }}>Reason is required</div>}
		  {props.textarefun && props.showTextArea && (
			<Row>
			  <Input
				style={{ width: '70%', marginLeft: 'auto', marginRight: 'auto' }}
				bsSize="md"
				type="textarea"
				name="textremarks"
				id="remarksid"
				onChange={props.textarefun}
			  />
			</Row>
		  )}
		  <Row>
			<Col style={{ 
				//marginLeft: '32%',
				marginTop: '3%',
				display: 'flex',
    			alignItems: 'center',
    			justifyContent: 'center',
    			flex: 1	
			}}>
			  {
				<Button id="btn1" style={{ marginRight: '1%' }} onClick={props.button1fun}>
				  {props.confirmButton}
				</Button>
			  }
			  {
				<Button id="btn2" onClick={props.toggle}>
				  {'CANCEL'}
				</Button>
			  }
			</Col>
		  </Row>
		</ModalBody>
	  </Modal>
	</div>
);

export const ToolTip = props => {
  const [tooltipOpen, setTooltipOpen] = useState(false),
    toggle = () => setTooltipOpen(!tooltipOpen);
  return (
    <div style={props.style}>
      <FaInfoCircle href="#" id={props.target} size="1.5em" color="blue" />
      <Tooltip placement="right" isOpen={tooltipOpen} target={props.target} toggle={toggle}>
        {props.message}
      </Tooltip>
    </div>
  );
};

export const filterValidPools = (validPools, userPoolAccess) => {
    return userPoolAccess && userPoolAccess.filter(value => validPools.indexOf(value) >= 0);
}
